import Goal from '../assets/images/events/goal.svg';
import OwnGoal from '../assets/images/events/own-goal.svg';
import RedCard from '../assets/images/events/red-card.svg';
import Stats from '../assets/images/events/stats.svg';
import DoubleYellowCard from '../assets/images/events/double-yellow-card.svg';
import Substitution from '../assets/images/events/substitution.svg';
import Var from '../assets/images/events/var.svg';
import Whistle from '../assets/images/events/whistle.svg';
import YellowCard from '../assets/images/events/yellow-card.svg';
import CheckFlag from '../assets/images/events/check-flag.svg';
import Cloud from '../assets/images/events/cloud.svg';
import Crash from '../assets/images/events/crash.svg';
import DNF from '../assets/images/events/dnf.svg';
import GreenLight from '../assets/images/events/green-light.svg';
import Prosecco from '../assets/images/events/prosecco.svg';
import PolePosition from '../assets/images/events/pole-position.svg';
import RedFlag from '../assets/images/events/red-flag.svg';
import TechnicalIssues from '../assets/images/events/technical-issues.svg';
import Warning from '../assets/images/events/warning.svg';
import BandieraGialla from '../assets/images/events/bandiera-gialla.svg';
import SafetyCar from '../assets/images/events/safety-car.svg';
import VirtualSafetyCar from '../assets/images/events/virtual-safety-car.svg';
import GoldMedal from '../assets/images/events/gold-medal.svg';
import SilverMedal from '../assets/images/events/silver-medal.svg';
import BronzeMedal from '../assets/images/events/bronze-medal.svg';
import OlympicRecord from '../assets/images/events/olympic-record.svg';
import WorldRecord from '../assets/images/events/world-record.svg';
import ItalianRecord from '../assets/images/events/italian-record.svg';
import SkyLogoNoIcon from '../assets/images/events/sky-logo-no-icon.svg';
import SkyLogo from '../assets/images/events/sky-logo.svg';

export type LbEventKey =
  | 'inizio partita'
  | 'fine 1t'
  | 'inizio 2t'
  | 'fine partita'
  | 'fine 2t'
  | 'inizio 1ts'
  | 'fine 1ts'
  | 'inizio 2ts'
  | 'fine 2ts'
  | 'inizio rigori'
  | 'sostituzione'
  | 'ammonizione'
  | 'espulsione'
  | 'doppia ammonizione'
  | 'autogoal'
  | 'goal'
  | 'VAR'
  | 'statistiche'
  | 'si parte'
  | 'problemi tecnici'
  | 'incidente'
  | 'pole position'
  | 'penalità'
  | 'ritiro'
  | 'bandiera rossa'
  | 'scende la pioggia'
  | 'prosecco time'
  | 'si parte'
  | 'bandiera a scacchi'
  | 'bandiera gialla'
  | 'safety car'
  | 'virtual safety car'
  | "medaglia d'oro"
  | "medaglia d'argento"
  | 'medaglia di bronzo'
  | 'record olimpico'
  | 'record mondiale'
  | 'record italiano'
  | 'Sky post'
  | 'Sky post senza icona';

export enum LbEventType {
  FOOTBALL = 'football',
  RACES = 'races',
  SPECIAL_EVENTS = 'special-events',
  SKY_POST = 'sky-post',
}

enum LbEventBorderColors {
  GREEN = '#00d209',
  RED = '#de0000',
  YELLOW = '#ffbc00',
  DARKBLUE = '#051045',
  LIGHTBLUE = '#73b0d7',
  WHITE = '#ffffff',
  GRADIENT = 'linear-gradient(135deg, #F59D00 0%, #E63A10 22.98%, #E40077 48.32%, #83388D 72.38%, #304392 100%)',
}

export type LbEvent = {
  text: string;
  borderColor?: string;
  backgroundColor?: string;
  icon: string;
  type: LbEventType;
  isIconHidden?: boolean;
};

export type LbEvents = Record<LbEventKey, LbEvent>;

export const events: LbEvents = {
  'inizio partita': {
    text: "calcio d'inizio!",
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'fine 1t': {
    text: 'intervallo!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'inizio 2t': {
    text: 'inizia il secondo tempo!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'fine partita': {
    text: 'finisce qui!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'fine 2t': {
    text: 'finisce il secondo tempo!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'inizio 1ts': {
    text: 'inizia il primo tempo supplementare!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'fine 1ts': {
    text: 'finisce il primo tempo supplementare!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'inizio 2ts': {
    text: 'inizia il secondo tempo supplementare!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'fine 2ts': {
    text: 'finisce il secondo tempo supplementare!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  'inizio rigori': {
    text: 'iniziano i rigori!',
    borderColor: LbEventBorderColors.GREEN,
    icon: Whistle,
    type: LbEventType.FOOTBALL,
  },
  sostituzione: {
    text: 'sostituzione',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: Substitution,
    type: LbEventType.FOOTBALL,
  },
  ammonizione: {
    text: 'ammonizione!',
    borderColor: LbEventBorderColors.YELLOW,
    icon: YellowCard,
    type: LbEventType.FOOTBALL,
  },
  espulsione: {
    text: 'espulsione!',
    borderColor: LbEventBorderColors.RED,
    icon: RedCard,
    type: LbEventType.FOOTBALL,
  },
  'doppia ammonizione': {
    text: 'doppia ammonizione!',
    borderColor: LbEventBorderColors.RED,
    icon: DoubleYellowCard,
    type: LbEventType.FOOTBALL,
  },
  autogoal: {
    text: 'autogoal!',
    borderColor: LbEventBorderColors.RED,
    icon: OwnGoal,
    type: LbEventType.FOOTBALL,
  },
  goal: {
    text: 'GOL!',
    borderColor: LbEventBorderColors.WHITE,
    backgroundColor: LbEventBorderColors.DARKBLUE,
    icon: Goal,
    type: LbEventType.FOOTBALL,
  },
  VAR: {
    text: 'VAR',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: Var,
    type: LbEventType.FOOTBALL,
  },
  statistiche: {
    text: 'statistiche',
    borderColor: LbEventBorderColors.LIGHTBLUE,
    icon: Stats,
    type: LbEventType.FOOTBALL,
  },
  'si parte': {
    text: 'si parte!',
    borderColor: LbEventBorderColors.GREEN,
    icon: GreenLight,
    type: LbEventType.RACES,
  },
  'problemi tecnici': {
    text: 'problemi tecnici!',
    borderColor: LbEventBorderColors.YELLOW,
    icon: TechnicalIssues,
    type: LbEventType.RACES,
  },
  incidente: {
    text: 'incidente!',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: Crash,
    type: LbEventType.RACES,
  },
  'pole position': {
    text: 'pole position!',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: PolePosition,
    type: LbEventType.RACES,
  },
  penalità: {
    text: 'penalità',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: Warning,
    type: LbEventType.RACES,
  },
  ritiro: {
    text: 'ritiro',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: DNF,
    type: LbEventType.RACES,
  },
  'bandiera rossa': {
    text: 'bandiera rossa!',
    borderColor: LbEventBorderColors.RED,
    icon: RedFlag,
    type: LbEventType.RACES,
  },
  'scende la pioggia': {
    text: 'scende la pioggia',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: Cloud,
    type: LbEventType.RACES,
  },
  'prosecco time': {
    text: 'prosecco time!',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: Prosecco,
    type: LbEventType.RACES,
  },
  'bandiera a scacchi': {
    text: 'bandiera a scacchi!',
    borderColor: LbEventBorderColors.WHITE,
    backgroundColor: LbEventBorderColors.DARKBLUE,
    icon: CheckFlag,
    type: LbEventType.RACES,
  },
  'bandiera gialla': {
    text: 'bandiera gialla!',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: BandieraGialla,
    type: LbEventType.RACES,
  },
  'safety car': {
    text: 'safety car!',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: SafetyCar,
    type: LbEventType.RACES,
  },
  'virtual safety car': {
    text: 'virtual safety car!',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: VirtualSafetyCar,
    type: LbEventType.RACES,
  },
  "medaglia d'oro": {
    text: "Medaglia d'oro",
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: GoldMedal,
    type: LbEventType.SPECIAL_EVENTS,
  },
  "medaglia d'argento": {
    text: "Medaglia d'argento",
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: SilverMedal,
    type: LbEventType.SPECIAL_EVENTS,
  },
  'medaglia di bronzo': {
    text: 'Medaglia di bronzo',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: BronzeMedal,
    type: LbEventType.SPECIAL_EVENTS,
  },
  'record olimpico': {
    text: 'Record olimpico',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: OlympicRecord,
    type: LbEventType.SPECIAL_EVENTS,
  },
  'record mondiale': {
    text: 'Record mondiale',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: WorldRecord,
    type: LbEventType.SPECIAL_EVENTS,
  },
  'record italiano': {
    text: 'Record italiano',
    borderColor: LbEventBorderColors.DARKBLUE,
    icon: ItalianRecord,
    type: LbEventType.SPECIAL_EVENTS,
  },
  'Sky post': {
    text: 'Sky post',
    borderColor: LbEventBorderColors.GRADIENT,
    icon: SkyLogo,
    type: LbEventType.SKY_POST,
  },
  'Sky post senza icona': {
    text: 'Sky post senza icona',
    borderColor: LbEventBorderColors.GRADIENT,
    icon: SkyLogoNoIcon,
    isIconHidden: true,
    type: LbEventType.SKY_POST,
  },
};
